import { BUTTON_FONT } from 'components/landing/constants';
import ButtonContainer from 'core/button-container';
import Image from 'core/image';
import Item from 'components/landing/faq/item';
import LandingSection from 'components/landing/components/landing-section';
import maxFace from 'static/img/icons/CECA_Max_FaceColor.png';
import { PinkButton } from 'core/buttons/buttons';
import Title from 'core/title';
import useGetSeoTextByIndex from 'hooks/useGetSeoTextByIndex';
import { useTranslations } from 'next-intl';

const Faq = () => {
    const { seoText, verification } = useGetSeoTextByIndex('faq');
    const t = useTranslations('faq');

    if (!verification) {
        // TODO: Add sentry controlled exception
        return null;
    }

    // Split rows into groups of 10
    const rows = [];
    let faqItemList = [];
    for (let i = 1; i < 30; i++) {
        if (i % 10 === 0 || i === 29) {
            rows.push(faqItemList);
            faqItemList = [];
        }

        // Check for all faq items for different cultures
        try {
            if (seoText[`item${i}`].title !== ' ') {
                faqItemList.push(
                    <Item
                        title={seoText[`item${i}`].title}
                        detail={seoText[`item${i}`].sentence1}
                        key={i}
                    />
                );
            }
        } catch {
            // TODO: Add sentry controlled warning
        }
    }

    return (
        <LandingSection>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginBottom: '2rem'
                }}
            >
                <Image
                    src={maxFace}
                    width={100}
                    height={100}
                    alt={t('alt-image')}
                />
            </div>
            <Title align content={seoText.section_title} />
            {rows.map((row, index) => (
                <div
                    style={{
                        marginTop: index === 0 ? '2rem' : '',
                        marginBottom: index === rows.length - 1 ? '2rem' : ''
                    }}
                    key={index}
                >
                    {row}
                </div>
            ))}
            <ButtonContainer>
                <PinkButton
                    label={`${t('button.label')} &#10095;`}
                    href={t('button.href')}
                    propsButton={BUTTON_FONT}
                />
            </ButtonContainer>
        </LandingSection>
    );
};

export default Faq;
